/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import type { Filter } from '@coursera-web/cds-labs';
import { CollectionsModule } from '@coursera-web/cds-labs';

import SectionHeadingComponent from 'bundles/browse-common/components/SectionHeadingComponent';
import type { DegreeCollectionSet } from 'bundles/browse-common/types/degreeCollection';

import _t from 'i18n!nls/browse-common';

type Props = {
  collectionSet: DegreeCollectionSet;
  isLoading?: boolean;
  showPageTitleHeadingSize?: boolean;
};

const styles = {
  headingSpacing: css`
    margin-bottom: var(--cds-spacing-150);
  `,
};

const DegreeCollectionComponent = ({ collectionSet, isLoading, showPageTitleHeadingSize = false }: Props) => {
  const filters: Filter[] = [];
  const [currentCollectionSetIndex, setCurrentCollectionSetIndex] = useState(0);
  const collectionSetList = Object.values(collectionSet);

  if (collectionSet.all.entities.length === 0) {
    return null;
  }

  const currentCollection = collectionSetList[currentCollectionSetIndex];

  if (!isLoading) {
    collectionSetList.forEach((collection) => {
      filters.push({
        id: collection.collectionId,
        filterName: collection.title,
      });
    });
  }

  const handleFilterChange = (index: number, filterName: string) => {
    // TODO: Add eventing?
    setCurrentCollectionSetIndex(index);
  };

  return (
    <CollectionsModule
      alwaysShowChipFilters
      isCollectionsLoading={isLoading}
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      collections={[currentCollection]}
      filters={filters}
      onFilterChange={handleFilterChange}
      currentCollectionSetIndex={currentCollectionSetIndex}
      backgroundColor="white"
      layout="text-top/image-bottom"
      customHeadline={
        <SectionHeadingComponent
          showPageTitleHeadingSize={showPageTitleHeadingSize}
          additionalStyles={styles.headingSpacing}
        >
          {_t('Online degrees')}
        </SectionHeadingComponent>
      }
    />
  );
};

export default DegreeCollectionComponent;
